// import { useMemo } from 'react';
// import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { Logo } from 'common/components';

import { AUTH_ROUTES } from '../../routes';

const AuthLayout = () => {
  // const { t } = useTranslation();

  // const menuItems = useMemo(
  //   () =>
  //     [
  //       {
  //         to: AUTH_ROUTES.login.to,
  //         label: t('authLayout.menu.login'),
  //       },
  //       {
  //         to: AUTH_ROUTES.signUp.to,
  //         label: t('authLayout.menu.signUp'),
  //       },
  //     ].map(({ to, label }) => ({
  //       key: to,
  //       label: <Link to={to}>{label}</Link>,
  //     })),
  //   [t]
  // );

  return (
    <><header>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-3 col-sm-3 col-xs-12'>
            <Logo to={AUTH_ROUTES.login.to} size="large" />
          </div>

          <div className='col-md-9 col-sm-9 col-xs-12'>
          </div>

          <div className='col-md-12 col-sm-12 col-xs-12'>
            <h2 className='registration-heading'>Avanse Payment Portal</h2>
          </div>

        </div>
      </div>
    </header>
      <Outlet /></>
  );
};

export default AuthLayout;
